import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Button, Tooltip } from '@material-ui/core';
import MaterialTable from 'material-table';
import * as S from './styles';
import api from '../../../../services/api';
import moment from 'moment';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import { toast } from 'react-toastify';
import '../../TargetReport/TableContent/index.css';
import CallEndIcon from '@material-ui/icons/CallEnd';

function TableContent({ tableData, totalTableData, onlyApproved, selectedAnchor }) {
  const { periodo } = useParams();
  const [totalTable, setTotalTable] = useState();
  const [bodyTable, setBodyTable] = useState();
  const [propertySorted, setPropertySorted] = useState({});
  const formatterPercent = new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  useEffect(() => {
    if (tableData) {
      tableData.forEach((elm) => {
        if (elm.dataEnvioEmailAncora == null) {
          elm.dataEnvioEmailAncora = 'None';
        }
      })
      setTable(tableData);
    }
  }, [tableData]);

  useEffect(() => {
    if (totalTableData) {
      if (totalTableData.fechadoReceitaBruta || totalTableData.fechadoReceitaBruta === 0) {
        setTotalTable([
          {
            nome: 'Ofertado',
            valorNotasFiscais: totalTableData.ofertaValorNotasFiscais,
            valorAntecipacao: totalTableData.ofertaValorAntecipacoes,
            receitaBruta: totalTableData.ofertaReceitaBruta,
            receitaLiquida: totalTableData.ofertaReceitaLiquida,
            taxa: totalTableData.ofertaTaxa,
            desagio: totalTableData.ofertaDesagio,
            prazoMedio: totalTableData.ofertaPrazoMedio,
          },
          {
            nome: 'Fechado',
            valorNotasFiscais: totalTableData.fechadoValorNotasFiscais,
            valorAntecipacao: totalTableData.fechadoValorAntecipacoes,
            receitaBruta: totalTableData.fechadoReceitaBruta,
            receitaLiquida: totalTableData.fechadoReceitaLiquida,
            taxa: totalTableData.fechadoTaxa,
            desagio: totalTableData.fechadoDesagio,
            prazoMedio: totalTableData.fechadoPrazoMedio,
          },
        ]);
      } else {
        setTotalTable([
          {
            nome: '',
            valorNotasFiscais: totalTableData.valorNotasFiscais,
            valorAntecipacao: totalTableData.valorAntecipacao,
            receitaBruta: totalTableData.receitaBruta,
            receitaLiquida: totalTableData.receitaLiquida,
            desagio: totalTableData.desagio,
            taxa: totalTableData.taxa,
            prazoMedio: totalTableData.prazoMedio,
          },
        ]);
      }
    }
  }, [totalTableData]);

  const sortTable = (param) => {
    setTable(tableData.sort(dynamicSort(param)));
    if (param === 'cnpjCpf') {
      setTable(tableData.sort(dynamicSort('docLength')));
    }
  };

  function dynamicSort(property) {
    let sortOrder = 1;
    if (propertySorted[property] !== undefined) {
      sortOrder = propertySorted[property] * -1;
    }
    if (property === 'docLength') {
      return function (a, b) {
        const result = (a.cnpjCpf.length < b.cnpjCpf.length) ? -1 : (a.cnpjCpf.length > b.cnpjCpf.length) ? 1 : 0;
        return result * propertySorted.cnpjCpf * -1;
      }
    }
    setPropertySorted(properties => ({ ...properties, [property]: sortOrder }));
    return function (a, b) {
        const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
  }

  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const toCurrency = (e) => {
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span></span>
          <span>{e ? formatter.format(e) : '0,00'}</span>
        </div>
      </>
    );
  };

  const setTable = (data) => {
    localStorage.setItem('startRow', 1)
    setBodyTable(data?.map(function (item, index) {
      let backColor = 'white';
      if (item.tipoRegistro === 'TotalAncora') {
        localStorage.setItem('startRow', ((index + 1) % 2) === 0 ? 1 : 0)
      }
      if ((index % 2) === parseInt(localStorage.getItem('startRow'))) {
        backColor = '#EEEEEE';
      }
      return (
        <>
          <TableRow style={{ backgroundColor: item.tipoRegistro === 'TotalAncora' ? '#C4C4C4' : (item.status?.toString().includes('provad') && periodo == 'diario'  ? '#87cefa' : backColor), cursor: item.tipoRegistro === 'TotalAncora' ? 'default' : 'pointer' }}
            onClick={() => {
              if (item.antecipacaoId && item.tipoRegistro !== 'TotalAncora') {
                window.localStorage.setItem('operationFromReport', JSON.stringify(item));
                window.location = '/app/operacao-antecipacao';
              }
            }}
          >
            {(selectedAnchor?.ancoraId === 999999 || selectedAnchor?.plataformaId > 0) && item.tipoRegistro !== 'TotalAncora' && (
              <Tooltip placement="top" title={
                item.analistas ? 
                <div dangerouslySetInnerHTML={{__html: item.analistas}}></div> :
                ''
              }>
                <TableCell className="fixed-column" align="left"
                  style={{ backgroundColor: item.tipoRegistro === 'TotalAncora' ? '#C4C4C4' : (item.status?.toString().includes('provad') && periodo == 'diario'  ? '#87cefa' : backColor) }}
                >
                  {item.apelido}
                </TableCell>
              </Tooltip>
            )}
            <TableCell align="left">{item.destinoPagamento}</TableCell>
            {item.tipoRegistro === 'TotalAncora' && (
              <TableCell align="center" style={{ fontWeight: item.tipoRegistro === 'TotalAncora' ? 'bold' : 'normal' }} colSpan={5}>{item.fornecedor}</TableCell>
            )}
            {item.tipoRegistro !== 'TotalAncora' && (
              <TableCell align="center">{item.quantidade}</TableCell>
            )}
            {item.tipoRegistro !== 'TotalAncora' && (
              <TableCell align="center">{moment(item.dataPagamento).format('DD/MM/YYYY')}</TableCell>
            )}
            {item.tipoRegistro !== 'TotalAncora' && (
              <TableCell align="right">{item.cnpjCpf}</TableCell>
            )}
            {item.tipoRegistro !== 'TotalAncora' && (
              <TableCell align="left">{item.fornecedor}</TableCell>
            )}
            <TableCell style={{ fontWeight: item.tipoRegistro === 'TotalAncora' ? 'bold' : 'normal' }} align="right">{toCurrency(item.valorNotasFiscais)}</TableCell>
            <TableCell style={{ fontWeight: item.tipoRegistro === 'TotalAncora' ? 'bold' : 'normal' }} align="right">{toCurrency(item.valorAntecipacao)}</TableCell>
            <TableCell style={{ fontWeight: item.tipoRegistro === 'TotalAncora' ? 'bold' : 'normal' }} align="right">{toCurrency(item.receitaBruta)}</TableCell>
            <TableCell style={{ fontWeight: item.tipoRegistro === 'TotalAncora' ? 'bold' : 'normal' }} align="right">{toCurrency(item.receitaLiquida)}</TableCell>
            <TableCell style={{ fontWeight: item.tipoRegistro === 'TotalAncora' ? 'bold' : 'normal' }} align="right">{formatterPercent.format(item.taxa / 100)}</TableCell>
            <TableCell style={{ fontWeight: item.tipoRegistro === 'TotalAncora' ? 'bold' : 'normal' }} align="right">{formatterPercent.format(item.desagio / 100)}</TableCell>
            <TableCell style={{ fontWeight: item.tipoRegistro === 'TotalAncora' ? 'bold' : 'normal' }} align="right">{item.prazoMedio}</TableCell>
              <TableCell align="center">
                {item.contatoEfetuado !== null ? (
                  <Tooltip placement="top" title={moment(item.contatoEfetuado).format('DD/MM/YYYY HH:mm')}>
                      <CallEndIcon style={{fontSize: 20 ,color: '#232c63',}} />
                  </Tooltip>
                ) : ''}
              </TableCell>
            {/* <TableCell align="right">{formatterPercent.format(item.desagio / 100)}</TableCell> */}
            {periodo === 'diario' && (
              <TableCell align="center">
                {item.dataEnvioEmailFornecedor
                  ? moment(item.dataEnvioEmailFornecedor).format('DD/MM/YYYY HH:mm')
                  : ''}
              </TableCell>
            )}
            {periodo === 'diario' && (
              <TableCell align="center" style={{ color: item.dataEnvioEmailAncora === 'None' ? backColor : '' }}>
                {item.dataEnvioEmailAncora !== null && item.dataEnvioEmailAncora !== "None"
                  ? moment(item.dataEnvioEmailAncora).format('DD/MM/YYYY HH:mm')
                  : ''}
              </TableCell>
            )}
          </TableRow>
        </>
      );
    }));
  }

  const bodyTableTotal = totalTable?.map(function (item, index) {
    const backColor = '#EEEEEE';
    return (
      <>
        <TableRow style={{ backgroundColor: onlyApproved ? '#87cefa' : backColor }}>
          {periodo === 'diario' && <TableCell align="center">{item.nome}</TableCell>}
          <TableCell align="right">{toCurrency(item.valorNotasFiscais)}</TableCell>
          <TableCell align="right">{toCurrency(item.valorAntecipacao)}</TableCell>
          <TableCell align="right">{toCurrency(item.receitaBruta)}</TableCell>
          <TableCell align="right">{toCurrency(item.receitaLiquida)}</TableCell>
          <TableCell align="right">{formatterPercent.format(item.taxa / 100)}</TableCell>
          <TableCell align="right">{formatterPercent.format(item.desagio / 100)}</TableCell>
          <TableCell align="right">{item.prazoMedio}</TableCell>
        </TableRow>
      </>
    );
  });

  return (
    <>
      <div
        className="report-tables"
        style={{ margin: '20px 50px', zIndex: '0', position: 'relative' }}
      >
        <div style={{ maxWidth: '900px', margin: '5px auto' }}>
          <h3 style={{ textAlign: 'center' }}>Totalizador</h3>
          <Table style={{ margin: '15px', backgroundColor: 'white' }}>
            <TableHead style={{ backgroundColor: '#232C63' }}>
              <TableRow>
                {periodo === 'diario' && (
                  <TableCell
                    style={{ color: 'white', fontWeight: 'bold' }}
                    align="center"
                  >Status</TableCell>
                )}
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                  Notas Fiscas
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                  Antecipações
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                  Receita Bruta
                </TableCell>
                  <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                    Receita Líquida
                  </TableCell>
                  <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                    Taxa
                  </TableCell>
                  <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                    Deságio
                  </TableCell>
                  <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                    Prazo
                  </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{bodyTableTotal}</TableBody>
          </Table>
        </div>
        
        <div style={{ overflowX: 'auto' }}>
          <Table style={{ margin: '25px auto', maxWidth: '1700px' }}>
            <TableHead style={{ backgroundColor: '#232C63', cursor: 'pointer' }}>
              <TableRow>
                {(selectedAnchor?.ancoraId === 999999 || selectedAnchor?.plataformaId > 0) && (
                  <TableCell className="fixed-column" style={{ color: 'white', fontWeight: 'bold', backgroundColor: '#232C63' }} align="left" onClick={() => sortTable('apelido')}>
                    Rede
                  </TableCell>
                )}
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" onClick={() => sortTable('destinoPagamento')}>
                  Pagto
                </TableCell>
                <TableCell
                  style={{ color: 'white', fontWeight: 'bold', width:'35px' }}
                  align="center"
                  width="100px"
                  onClick={() => sortTable('quantidade')}
                >Qtd
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" onClick={() => sortTable('dataPagamento')}>
                  Data Pagto
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" onClick={() => sortTable('cnpjCpf')}>
                  Cnpj / Cpf
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="left" onClick={() => sortTable('fornecedor')}>
                  Fornecedor
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" onClick={() => sortTable('valorNotasFiscais')}>
                  Notas Fiscais
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" onClick={() => sortTable('valorAntecipacao')}>
                  Antecipações
                </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" onClick={() => sortTable('receitaBruta')}>
                  Receita Bruta
                </TableCell>
                  <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" onClick={() => sortTable('receitaLiquida')}>
                    Receita Líquida
                  </TableCell>
                <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" onClick={() => sortTable('taxa')}>
                  Taxa
                </TableCell>
                  <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" onClick={() => sortTable('desagio')}>
                    Deságio
                  </TableCell>
                  <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" onClick={() => sortTable('prazoMedio')}>
                    Prazo
                  </TableCell>
                  <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" onClick={() => sortTable('contatoEfetuado')}>
                  Cto
                </TableCell>
                {/* <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="right">Desagio</TableCell> */}
                {periodo === 'diario' && (
                  <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" onClick={() => sortTable('dataEnvioEmailFornecedor')}>
                    Env. Fornecedor
                  </TableCell>
                )}
                {periodo === 'diario' && (
                  <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center" onClick={() => sortTable('dataEnvioEmailAncora')}>
                    Env. Rede
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>{bodyTable}</TableBody>
          </Table>
        </div>
      </div>
    </>
  );
}

export default TableContent;
